import { Link, type LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildLocalePath, isPublicRoute } from "./localePath";

export function LocaleLink({ to, ...rest }: LinkProps) {
  const { i18n } = useTranslation();
  const target = typeof to === "string" && isPublicRoute(to)
    ? buildLocalePath(i18n.language, to)
    : to;
  return <Link to={target} {...rest} />;
}
